import React from 'react';

import ProjectIconUI5 from "../../../core/gd-ui/project-icon/project-icon-ui5";
import ProjectSession from "../../model2/project/project-session";
import HintPopover from "../../gd-ui/hint-popover/hint-popover"

type Props =  {

    className?      : string

    projectId       : ID
    maxParents?     : number // max numbers of parent we want to display

    showIcon?       : boolean
    colorize?       : boolean
    disabled?       : boolean
    hintFullPath?   : boolean

    onClickProject? : callback
}

export default class BreadcrumbsUI5 extends React.Component<Props> {

    // static propTypes = {
    //
    //     projectId: PropTypes.string,
    //     maxParents: PropTypes.number, // max numbers of parent we want to display
    //
    //     showIcon: PropTypes.bool,
    //     colorize: PropTypes.bool,
    //     disabled: PropTypes.bool,
    //
    //     onClickProject: PropTypes.func,
    // }

    static defaultProps = {
        showIcon    : true,
        colorize    : true,

        // maxParents  : 3, done below
    }

    onClickProject = (e:React.SyntheticEvent, project:ProjectSession) => {
        if (!project.access) return

        if(!this.props.disabled) {
            e.stopPropagation();

            if (this.props.onClickProject) {
                this.props.onClickProject(project.id);
            } else {
                // gd.goTo('p/{0}'.f(project.id));
                project.goTo()
            }
        }
    }

    getHint = () => {
        let res

        if (this.props.projectId) {
            const project : ProjectSession = gd.session.projects.get(this.props.projectId)!

            // @ts-ignore
            const parents = gd.tree.findProjectParents(gd.tree.getProject(this.props.projectId)).concat(project).map((p:any) => p.name);
            res = parents.join(' / ')
        }

        return res
    }

    render() {

        const maxParents = this.props.maxParents || 3

        const parentProjects = this.props.projectId
            ? gd.tree.findProjectParents(gd.tree.getProject(this.props.projectId)).map(p=>p.id).concat([this.props.projectId]).reverse()
            : []
        ;

        const projects      : any[] = []
        const breadcrumbs   : any[] = [];

        _.map(parentProjects, (projectId,key : number)=>{
            if (key > maxParents) return;

            const project = gd.session.projects.get(projectId);
            if (project) projects.push(project);
        })

        _.map(projects, (project,key)=>{
            if (key === 0) {
                const itemMinWidth = _.min([gd.utils.getTextWidth(project.name) + (this.props.showIcon ? 20 : 0), 100]);
                breadcrumbs.unshift(
                    <div key        = {key}
                         className  = "breadcrumb-item"
                         style      = {{minWidth: itemMinWidth}}
                         onClick    = {(e)=>{this.onClickProject(e, project)}}>
                        {this.props.showIcon && <ProjectIconUI5 className="item-icon m-r-5" projectId={project.id} colorize={this.props.colorize}/>}
                        <div className="label">{project.name}</div>
                    </div>
                );
            } else {
                breadcrumbs.unshift(
                    <React.Fragment key={key}>
                        <div className  = "breadcrumb-item"
                             onClick    = {(e)=>{this.onClickProject(e, project)}}><div className="label">{project.name}</div></div>
                        <div className="separator"/>
                    </React.Fragment>
                );
            }
        })

        return (
            <div className={Classes("ui5-breadcrumbs", this.props.className)}>
                {breadcrumbs}
                {this.props.hintFullPath && <HintPopover hint={this.getHint()} multiline={true}/>}
            </div>
        );
    }
}
